import React, { Component } from 'react'
import { get } from "lodash"

import { checkIsValidResult } from "./static.resultData"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import ButtonFill from "../../../shared/items/controls/buttonFill"

class ResultNextStepButton extends Component {
  componentDidUpdate() {
    const { data, onSetSuccessValidate } = this.props

    if (checkIsValidResult(data))
      onSetSuccessValidate("result")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["result", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(ResultNextStepButton)